import { autoinject, transient } from "aurelia-framework";

@autoinject
@transient()
export class SendReceiveRmail {

    public imgUrl: string = require('../../../../../images/quickstart/02.png');
    constructor() { }
}
